export default __webpack_public_path__ + "static/media/CNo.36-0.be4d8d2d.jpg";